export const reportchildren = [
  {
    path: '/reportManage/domreport',
    name: 'domreport',
    component: () => import('@/page/reportManage/report/domreport'),
    meta: {
      title: '国内机票报表',
      role: 'jpbb'
    }
  },
  {
    path: '/reportManage/intreport',
    name: 'intreport',
    component: () => import('@/page/reportManage/report/intreport'),
    meta: {
      title: '国际机票报表',
      role: 'gjbb'
    }
  },
  {
    path: '/reportManage/trainreport',
    name: 'trainreport',
    component: () => import('@/page/reportManage/report/trainreport'),
    meta: {
      title: '火车票报表',
      role: 'hcbb'
    }
  },
  {
    path: '/reportManage/hotelreport',
    name: 'hotelreport',
    component: () => import('@/page/reportManage/report/hotelreport'),
    meta: {
      title: '酒店报表',
      role: 'jdbb'
    }
  }
]

export const travelReport = [
  {
    path: '/reportManage/dataReport/List',
    name: 'dataReportList',
    meta: {
      title: '商旅综述',
      role: 'slzs'
    },
    redirect: '/reportManage/dataReport/consumptionMonthly'
  },
  {
    path: '/reportManage/dataReport/Ticket',
    name: 'dataReportTicket',
    meta: {
      title: '机票',
      role: 'jpfx'
    },
    redirect: '/reportManage/dataReport/aircraftMonthDetailed'
  },
  {
    path: '/reportManage/dataReport/Hotel',
    name: 'dataReportHotel',
    meta: {
      title: '酒店',
      role: 'jdfx'
    },
    redirect: '/reportManage/dataReport/hotelMonthCount'
  },
  {
    path: '/reportManage/dataReport/Train',
    name: 'dataReportTrain',
    meta: {
      title: '火车票',
      role: 'hcfx'
    },
    redirect: '/reportManage/dataReport/trainCountMonthly'
  }
]

export const dataReportchildren = [
  {
    path: '/reportManage/dataReport/summary',
    name: 'summary',
    component: () => import('@/page/reportManage/dataReport/summary'),
    meta: {
      title: '汇总报表',
      role: 'hztj'
    }
  },
  {
    path: '/reportManage/dataReport/skipProfitList',
    component: () => import('@/page/reportManage/dataReport/skipProfitList'),
    name: 'skipProfitList',
    meta: {
      title: '企业周月年统计',
      role: 'ydtj'
    }
  }
]
export const dataReportList = [
  {
    path: '/reportManage/dataReport/consumptionMonthly',
    name: 'consumptionMonthly',
    component: () => import('@/page/reportManage/dataReport/consumptionMonthly'),
    meta: {
      title: '消费月度累计'
    }
  },
  // -------------------- 机票 --------------------
  {
    path: '/reportManage/dataReport/savingsAndLosses',
    name: 'savingsAndLosses',
    component: () => import('@/page/reportManage/dataReport/savingsAndLosses'),
    meta: {
      title: '节省与损失'
    }
  },
  {
    path: '/reportManage/dataReport/routeCount',
    name: 'routeCount',
    component: () => import('@/page/reportManage/dataReport/routeCount'),
    meta: {
      title: '航线'
    }
  },
  {
    path: '/reportManage/dataReport/dpsLosses',
    name: 'dpsLosses',
    component: () => import('@/page/reportManage/dataReport/dpsLosses'),
    meta: {
      title: '国内机票损失明细'
    }
  },
  {
    path: '/reportManage/dataReport/advanceBooking',
    name: 'advanceBooking',
    component: () => import('@/page/reportManage/dataReport/advanceBooking'),
    meta: {
      title: '员工提前预订统计'
    }
  },
  {
    path: '/reportManage/dataReport/advanceReserveDiscount',
    name: 'advanceReserveDiscount',
    component: () => import('@/page/reportManage/dataReport/advanceReserveDiscount'),
    meta: {
      title: '企业提前预订天数折扣'
    }
  },
  {
    path: '/reportManage/dataReport/deptSaleCount',
    name: 'deptSaleCount',
    component: () => import('@/page/reportManage/dataReport/deptSaleCount'),
    meta: {
      title: '部门机票消费及提前预订天数'
    }
  },
  {
    path: '/reportManage/dataReport/airlineCount',
    name: 'airlineCount',
    component: () => import('@/page/reportManage/dataReport/airlineCount'),
    meta: {
      title: '承运商'
    }
  },
  {
    path: '/reportManage/dataReport/airlineMonthCount',
    name: 'airlineMonthCount',
    component: () => import('@/page/reportManage/dataReport/airlineMonthCount'),
    meta: {
      title: '承运商累月统计'
    }
  },
  {
    path: '/reportManage/dataReport/aircraftMonthDetailed',
    name: 'aircraftMonthDetailed',
    component: () => import('@/page/reportManage/dataReport/aircraftMonthDetailed'),
    meta: {
      title: '机票当月金额'
    }
  },
  {
    path: '/reportManage/dataReport/cabins',
    name: 'cabins',
    component: () => import('@/page/reportManage/dataReport/cabins'),
    meta: {
      title: '舱位'
    }
  },
  {
    path: '/reportManage/dataReport/disCount',
    name: 'disCount',
    component: () => import('@/page/reportManage/dataReport/disCount'),
    meta: {
      title: '折扣率'
    }
  },
  {
    path: '/reportManage/dataReport/routeMonthCount',
    name: 'routeMonthCount',
    component: () => import('@/page/reportManage/dataReport/routeMonthCount'),
    meta: {
      title: '航线累月统计'
    }
  },
  // -------------------- 火车票 --------------------
  {
    path: '/reportManage/dataReport/trainCountMonthly',
    name: 'trainCountMonthly',
    component: () => import('@/page/reportManage/dataReport/trainCountMonthly'),
    meta: {
      title: '火车票月度明细'
    }
  },
  {
    path: '/reportManage/dataReport/traNewMonthCount',
    name: 'traNewMonthCount',
    component: () => import('@/page/reportManage/dataReport/traNewMonthCount'),
    meta: {
      title: '火车票当月金额'
    }
  },
  {
    path: '/reportManage/dataReport/traTripCount',
    name: 'traTripCount',
    component: () => import('@/page/reportManage/dataReport/traTripCount'),
    meta: {
      title: '火车票行程'
    }
  },
  // -------------------- 酒店 --------------------
  {
    path: '/reportManage/dataReport/hotelNowMonth',
    name: 'hotelNowMonth',
    component: () => import('@/page/reportManage/dataReport/hotelNowMonth'),
    meta: {
      title: '酒店当月金额'
    }
  },
  {
    path: '/reportManage/dataReport/hotelReserveType',
    name: 'hotelReserveType',
    component: () => import('@/page/reportManage/dataReport/hotelReserveType'),
    meta: {
      title: '酒店预订方式'
    }
  },
  {
    path: '/reportManage/dataReport/hotelMonthCount',
    name: 'hotelMonthCount',
    component: () => import('@/page/reportManage/dataReport/hotelMonthCount'),
    meta: {
      title: '酒店月度明细'
    }
  },
  {
    path: '/reportManage/dataReport/hotelStart',
    name: 'hotelStart',
    component: () => import('@/page/reportManage/dataReport/hotelStart'),
    meta: {
      title: '酒店星级分析'
    }
  }
]

const manageRouter = [{
  // 报表
  path: '/reportManage',
  name: 'reportManage',
  redirect: '/reportManage/domreport',
  meta: {

  },
  component: () => import('@/page/reportManage/index'),
  children: (reportchildren).concat(travelReport).concat(dataReportchildren).concat(dataReportList)
}]

export default manageRouter



// WEBPACK FOOTER //
// ./src/router/modules/reportManage.js